const SOUNDS = new Map([
  [
    "silent",
    {
      audio: new Audio("silence.mp3"),
      volume: 0.0,
      autoplay: true,
      loop: true,
    },
  ],

  [
    "ringing",
    {
      audio: new Audio("ring.mp3"),
      volume: 1.0,
      autoplay: true,

      loop: true,
    },
  ],

  [
    "rejected",
    {
      audio: new Audio("silence.mp3"),
      volume: 0.5,
      autoplay: true,

      loop: false,
    },
  ],
]);

let initialized = false;

export default {
  /**
   * Play all the sounds so they will play in mobile browsers at any time
   */
  initialize() {
    if (initialized) return;

    for (const sound of SOUNDS.values()) {
      sound.audio.volume = 0;

      try {
        sound.volume = 0;
        sound.audio.play();
        sound.audio.pause();
      } catch (error) {
        console.log("Unable to Play Sound");
      }
    }

    initialized = true;
  },

  /**
   * Play a sound
   * @param {String} name - Sound name
   * @param {[Float]} relativeVolume - Relative volume (0.0 - 1.0)
   */
  play(name, relativeVolume) {
    this.initialize();

    if (typeof relativeVolume !== "number") relativeVolume = 1.0;

    const sound = SOUNDS.get(name);

    if (!sound) throw new Error(`unknown sound name "${name}"`);

    try {
      sound.audio.pause();
      sound.audio.currentTime = 0.0;
      sound.audio.volume = (sound.volume || 1.0) * relativeVolume;
      sound.audio.play();
    } catch (error) {
      console.log("Unable to Play Sound");
    }
  },

  stop(name) {
    const sound = SOUNDS.get(name);

    if (!sound) throw new Error(`unknown sound name "${name}"`);

    sound.audio.pause();
    sound.audio.currentTime = 0.0;
  },
};
